import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import StateSelector from '../Forms/StateSelector/index.jsx';
import Alert from '../Alert/index.jsx';
import CMSContent from '../CMSContent/index.jsx';
import LoadingOverlay from '../LoadingOverlay/index.jsx';

import { AjaxService } from '../../Services/Ajax/index.jsx';


class EditAccount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validated: false,
      loading: false,
      error: null,
      user: null,
      countries: null
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.fetchComplete = this.fetchComplete.bind(this);
    this.onError = this.onError.bind(this);
    this.submitComplete = this.submitComplete.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.onChangeState = this.onChangeState.bind(this);
    this.onChangeCountry = this.onChangeCountry.bind(this);
    this.onChangesetNumber = this.onChangesetNumber.bind(this);

  }

  componentDidMount() {
    this.setState({ loading: true });

    var profileDetails = AjaxService.fetch('theme:user-profile-details');
    var countries = AjaxService.fetch('theme:countries');

    Promise.all([profileDetails, countries]).then(this.fetchComplete).catch(this.onError);

    // initialise intlTelInput on phone input element
    const phoneInputField = document.querySelector("#phone");
    window.phoneInput = window.intlTelInput(phoneInputField, {
      utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js",
      initialCountry: "au",
      fixDropdownWidth: true,
      nationalMode: false,
      formatOnDisplay: true
    });

  }

  fetchComplete(response) {
    if (response) {
      this.setState({
        loading: false,
        user: response[0],
        countries: response[1]
      });
    }
    window.phoneInput.setNumber(this.state.user.phone);
  }

  onChangeState(event) {
    this.setState(function(previousState) {
      var result = {};

      if (previousState && previousState.user) {
        var newUser = Object.assign({}, previousState.user);
        newUser.state = event.target.value;

        result.user = newUser;
      }

      return result;
    });
  }

  onChangeCountry(event) {
    this.setState(function(previousState) {
      var result = {};

      if (previousState && previousState.user) {
        var newUser = Object.assign({}, previousState.user);
        newUser.country = event.target.value;

        result.user = newUser;
      }

      return result;
    });
  }

  onChangesetNumber(event) {
    window.phoneInput.setNumber(event.target.value);
  }

  onSubmit(event) {
    event.preventDefault();

    var newState = { validated: true };

    var form = event.currentTarget;
    // Validate phone no field
    const phoneInputField = document.querySelector("#phone");
    if (window.phoneInput.isValidNumber()) {
      phoneInputField.setCustomValidity("");
    } else {
      phoneInputField.setCustomValidity("Please enter valid phone number");
    }
    phoneInputField.reportValidity();

    if (form.checkValidity()) {
      newState.loading = true;

      var formFields = [
        'display',
        'firstname',
        'lastname',
        'email',
        'company',
        'address-1',
        'address-2',
        'city',
        'postcode',
        'state',
        'country',
        'phone'
      ];

      var formData = [];
      for (var i = 0; i < formFields.length; i++) {
        var field = formFields[i];

        formData.push(field + '=' + encodeURIComponent(form.elements[field].value));
      }
      formData.push('nonce=' + this.props.nonce);

      var data = formData.join('&');

      AjaxService.post('theme:user-profile-edit', data)
        .then(this.submitComplete)
        .catch(this.onError);
    }

    this.setState(newState);
  }

  submitComplete(response) {
    if (response.error) {
      this.setState({ loading: false, error: response.message });
    } else {
      // do something.
      if (response.data) {
        window.location.href = window.location.href;
      } else {
        this.setState({
          loading: false,
          error: 'Submit was successful, but no response was received'
        });
      }
    }
  }

  onError(error) {
    console.error(error);
    this.setState({ loading: false, error: error.message });
  }

  closeAlert() {
    this.setState({ error: null });
  }

  getCountryOptions() {
    var result = [];

    result.push(<option key="empty" value="">Select a country/region...</option>);
    if (this.state.countries) {
      for (var i = 0; i < this.state.countries.length; i++) {
        var country = this.state.countries[i];

        result.push(<option key={country.key} value={country.key}>{country.name}</option>);
      }
    }


    return result;
  }

  render() {
    var content = [];
    var user = this.state.user;

    var username = '';
    var display = '';
    var firstname = '';
    var lastname = '';
    var email = '';
    var company = '';
    var address1 = '';
    var address2 = '';
    var city = '';
    var postcode = '';
    var state = '';
    var country = '';
    var phone = '';

    if (user) {
      username = user.username;
      display = user.display;
      firstname = user.firstname;
      lastname = user.lastname;
      email = user.email;
      company = user.company;
      address1 = user['address-1'];
      address2 = user['address-2'];
      city = user.city;
      postcode = user.postcode;
      state = user.state;
      country = user.country;
      phone = user.phone;
    }

    content.push(
      <div key="content" className="mt-3">
        <CMSContent content="<h1>Personal Details</h1>" />
        <LoadingOverlay disabled={! this.state.loading}>
          <Form noValidate validated={this.state.validated} onSubmit={this.onSubmit}>
            <Row className="my-3">
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="username">
                    Username&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    id="username"
                    readOnly
                    placeholder="Username"
                    value={username}
                  />
                  <Form.Text muted>
                    To change your username, please contact our support team.
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Row className="my-3">
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="display">
                    Display Name&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    name="display"
                    type="text"
                    id="display"
                    placeholder="Display Name"
                    defaultValue={display}
                    required
                  />
                  <Form.Text muted>
                    The name used when you perform actions on the website (when you comment on an article, for example).
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Row className="my-3">
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="firstname">
                    First name&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    name="firstname"
                    type="text"
                    id="firstname"
                    placeholder="First name"
                    defaultValue={firstname}
                    required
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="lastname">
                    Last name&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    name="lastname"
                    type="text"
                    id="lastname"
                    placeholder="Last name"
                    defaultValue={lastname}
                    required
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="email">
                    Email address&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    name="email"
                    type="email"
                    id="email"
                    placeholder="Email address"
                    defaultValue={email}
                    required
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="company">
                    Company name (optional)
                  </Form.Label>
                  <Form.Control
                    name="company"
                    type="text"
                    id="company"
                    placeholder="Company name"
                    defaultValue={company}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="country">
                    Country / Region&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="country"
                    id="country"
                    custom
                    required
                    value={country}
                    onChange={this.onChangeCountry}
                  >
                    {this.getCountryOptions()}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="address-1">
                    Street address&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="address-1"
                    id="address-1"
                    placeholder="House number and street address"
                    defaultValue={address1}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="address-2" className="sr-only">
                    Street address 2
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="address-2"
                    id="address-2"
                    placeholder="Apartment, suite, unit, etc. (Optional)"
                    defaultValue={address2}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="city">
                    Town / City&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    id="city"
                    defaultValue={city}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <StateSelector
                  id="state"
                  name="state"
                  state={state}
                  onChange={this.onChangeState}
                  country={country}
                  countries={this.state.countries}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="postcode">
                    Postcode / Zip&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="postcode"
                    id="postcode"
                    defaultValue={postcode}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label htmlFor="phone">
                    Phone&nbsp;<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                      type="tel"
                      name="phone"
                      id="phone"
                      defaultValue={phone}
                      required
                      onChange={this.onChangesetNumber}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="my-3">
              <Button type="submit">Save</Button>
            </Form.Group>
          </Form>
        </LoadingOverlay>
      </div>
    );

    if (this.state.error) {
      content.push(
        <Alert key="error" onClose={this.closeAlert}>
          {this.state.error}
        </Alert>
      );
    }

    return content;
  }
}


export default EditAccount;

